import React, { type FC } from 'react';
import clsx from 'clsx';
import { AiText } from '@is24at/react-ui-core/src/components/AiText/AiText';
import { type Augmentation } from 'server/types/graphql';
import styles from './KeyFact.scss';

interface KeyFactProps {
  extraStyleNames?: string[];
  label?: string;
  value?: string | number | React.ReactElement;
  augmentation?: Augmentation;
}

const KeyFact: FC<KeyFactProps> = ({
  label,
  value,
  augmentation,
  extraStyleNames,
}) => (
  <div className={styles['key-fact']}>
    {augmentation ? (
      <AiText
        text={`${value} ${label || ''}`}
        className={clsx(styles['key-fact__value'], extraStyleNames)}
        data-testid="augmented-keyfact"
      />
    ) : (
      <>
        <span className={clsx(styles['key-fact__value'], extraStyleNames)}>
          {value}
        </span>
        <span className={styles['key-fact__label']}>{label}</span>
      </>
    )}
  </div>
);

export default KeyFact;
